<template>
  <div class="wrap">
    <Navbar :title="$t('page.walletList')" />
    <div class="content">
      <div class="bank_item" v-for="(item, index) in wallets" :key="index">
        <div class="delet">
          <div @click="deleteBank(item.id)">
            <van-icon name="delete-o" size="18" color="red" />
          </div>
        </div>
        <div class="bank" @click="select(item)">
          <div class="bank_cont">
            <!-- <div class="bank_img">
              <template v-if="item.bank == 'GCASH'">
                <img src="@/assets/new/bank/gcash.jpg" alt="">
              </template>
<template v-else>
                <img src="@/assets/new/bank/maya.jpg" alt="">
              </template>
</div> -->
            <div class="cont_right">
              <template v-if="item.open == 'crypto'">
                <div class="right_item">
                  <span>{{ $t('钱包类型') }}:</span>{{ item.name }}
                </div>
                <div class="right_item">
                  <span>{{ $t('地址') }}:</span>{{ item.card }}
                </div>
              </template>
              <template v-else>
                <div class="right_item">
                  <span>{{ $t('用户名') }}:</span>{{ item.name }}
                </div>
                <div class="right_item">
                  <span>{{ $t('银行名称') }}:</span>{{ item.open }}
                </div>
                <div class="right_item">
                  <span>{{ $t('银行代码') }}:</span>{{ item.card }}
                </div>
                <div class="right_item" v-if="item['ifsc_code']">
                  <span>{{ $t('newAdd.IFSCCODE') }}:</span>{{ item['ifsc_code'] }}
                </div>
              </template>
            </div>
          </div>
          <van-icon name="arrow" color="#eee" size="18" />
        </div>
        <!-- <van-radio-group v-model="checkedId">
          <van-radio :name="item.id" checked-color="#ee0a24" @click.stop="radioChange(item)">
            <div class="bank_radio">{{ item.id == checkedId ? $t('已默认') : $t('设为默认') }}</div>
          </van-radio>
        </van-radio-group> -->
      </div>
      <div class="button" @click="toAddCard">
        {{ $t("addWallet") }}
      </div>
    </div>
  </div>
</template>

<script>
import { GET_USER_BANK_INFO, COMMIT_USER_BANK_INFO, DEL_BANK } from "@/api";
import { getToken } from "@/utils";
import { NavBar, Toast, Icon, RadioGroup, Radio, Dialog } from "vant";
import Navbar from "@/components/JNav";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    Navbar,
    [Icon.name]: Icon,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    Dialog
  },
  data() {
    return {
      wallets: [],
      walletID: "",
      checkedId: '',
      defaultId: ''
    };
  },
  created() {
    this.getUserBankInfo();
  },
  mounted() {
    const { id } = this.$route.query;
    !!id && (this.walletID = id);
  },
  methods: {
    deleteBank(id) {
      Dialog.confirm({
        title: this.$t('提示'),
        message: this.$t('是否要删除此地址'),
        showCancelButton: true,
        confirmButtonText: this.$t('My.Button.Two'),
        cancelButtonText: this.$t('My.Button.One')
      }).then(async () => {
        Toast.loading();
        try {
          const res = await DEL_BANK({ id });
          Toast(res.msg);
          this.getUserBankInfo();
        } catch (error) {
          Toast.clear()
          error.msg && Toast(error.msg);
        }
      }).catch(() => { });
    },
    radioChange(item) {
      if (this.defaultId == item.id) return;
      this.editBank(item)
    },
    editBank(item) {
      Toast.loading();
      COMMIT_USER_BANK_INFO({ ...item, default: 1 }).then(res => {
        Toast.clear();
        const { ret, msg } = res.data;
        if (ret == 1) {
          this.defaultId = item.id;
          Toast(msg);
        } else {
          Toast(msg)
        }
      }).catch((e) => {
        Toast.clear();
      });
    },
    handleLinkPage(path) {
      if (getToken()) {
        this.$router.push(`/${path}`);
      } else {
        this.$toast($t("newAdd.NotLogin"));
        setTimeout(() => {
          this.$router.replace({ name: "login" });
        }, 1000);
      }
    },
    getUserBankInfo() {
      Toast.loading();
      GET_USER_BANK_INFO()
        .then((r) => {
          Toast.clear();
          const { data } = r.data;
          if (r.data.ret === 1 && data.length > 0) {
            Toast.clear();
            this.wallets = data;
            // this.checkedId = this.wallets.find(item => item.default > 0).id
            // this.defaultId = this.checkedId;
          }
        }).catch((e) => {
          Toast.clear();
          console.error(e);
        });
    },
    select(item) {
      if (this.$route.query.id) {
        item = { ...item, bank: item.bank }
        this.$cookie.set("selectBankInfo", JSON.stringify(item));
        this.$router.go(-1);
      } else {
        // this.handleLinkPage(`add-bank-card${!!item.id ? "?id=" + item.id : ""}`);
      }
    },
    toAddCard(item) {
      this.handleLinkPage(`add-bank-card`);
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: #f5f5f9;

  .content {
    padding: calc(16rem / 16);

    .bank_item {
      background: var(--light);
      padding: calc(10rem / 16);
      border-radius: calc(8rem / 16);
      margin-bottom: calc(10rem / 16);
      display: flex;
      flex-direction: column;
      gap: calc(10rem / 16);

      .delet {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .bank {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: calc(10rem / 16);

        .bank_cont {
          display: flex;
          align-items: center;
          // flex-direction: column;
          gap: calc(10rem / 16);

          .bank_img {
            img {
              height: calc(44rem / 16);
              display: block;
            }
          }

          .cont_right {
            flex: 1;

            .right_item {
              margin-top: calc(5rem / 16);
              font-size: calc(14rem / 16);
              color: #333;

              span {
                margin-right: calc(5rem / 16);
              }
            }
          }
        }
      }

      .bank_radio {
        font-size: calc(14rem / 16);
        color: #333;
      }
    }

    .button {
      background: #1989fa;
      height: calc(42rem / 16);
      padding: calc(5rem / 16) calc(10rem / 16);
      font-size: calc(14rem / 16);
      color: var(--light);
      text-align: center;
      line-height: 42rem / 16;
      border-radius: calc(8rem / 16);
      margin-top: calc(16rem / 16);
    }
  }
}
</style>